import restaurantsService from '../../services/restaurants'
import restaurantsStorage from '../../storage/restaurants'
import imagesService from '../../services/images'

const state = {
  restaurants: [],
  currentRestaurant: {
    restaurantId: '',
    restaurantName: '',
    organizationNumber: '',
    description: '',
    address: '',
    phoneNumber: '',
    city: '',
    postNumber: '',
    imageUrl: ''
  }
}

// getters
const getters = {
  getRestaurantById: (state) => (restaurantId) => {
    return state.restaurants
                .find(restaurant => restaurant.restaurantId === restaurantId);
  }
}

// actions
const actions = {
  async getRestaurantsAction(context) {
    if (state.restaurants == null){
      await restaurantsService.getRestaurantsByRestaurantOwner()
                              .then( data => { 
                                  console.log(data);
                                  context.commit('setRestaurantsState', data);
                                  restaurantsStorage.storeRestaurants(data); });
      context.commit('initializeCurrentRestaurantState');
    }

  },
  async loadRestaurantsFromStorageAction(context) {
    let data = restaurantsStorage.getRestaurants();
    await context.commit('setRestaurantsState', data);
    context.commit('initializeCurrentRestaurantState');
  },
  changeCurrentRestaurantAction(context, restaurant) {
    context.commit('setCurrentRestaurantState', restaurant);
  },
  async updateRestaurantAction(context, payload) {
    await restaurantsService.updateRestaurant(payload.restaurant);
    context.commit('updateRestaurantState', payload.restaurant);
    if (payload.image != null) {
      await imagesService.createImageForRestaurant(payload.restaurant.restaurantId, payload.image);
    }
    else {
      //delete image
      await imagesService.deleteImageForRestaurant(payload.restaurant.restaurantId);
    }
    //
    //update restaurant info to local storage
    //
    context.commit('updateRestaurantState', payload.restaurant);
  }

}

// mutations
const mutations = {
  setRestaurantsState(state, restaurants) {
    state.restaurants = restaurants;
  },
  initializeCurrentRestaurantState(state) {
    if (state.restaurants != null) {
      if (state.restaurants.length > 0) {
        state.currentRestaurant = state.restaurants[0];
      }
      
    }
  },
  setCurrentRestaurantState(state, currentRestaurant) {
    state.currentRestaurant = currentRestaurant;
  },
  updateRestaurantState(state, restaurant) {
    let index = state.restaurants.findIndex(r => r.restaurantId === restaurant.restaurantId); 
    if (index > -1) {
      state.restaurants[index] = restaurant;
      restaurantsStorage.clearRestaurantsInfo();
      restaurantsStorage.storeRestaurants(state.restaurants);
    }
    
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}